var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"pie_chart",attrs:{"id":"esg_risk_detail_pie"}},[_c('div',{attrs:{"id":"risk_detail_legend"}},_vm._l((_vm.pie_data),function(item,i){return _c('div',{key:i},[_c('div',{staticClass:"risk-detail-legend-box",style:('backgroundColor:' + item.color)}),_vm._v(" "),_c('div',[_vm._v(_vm._s(item.name))])])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-226d0981","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/insurance_esg/components/InsuranceESGDetailsPie.vue
// module id = null
// module chunks = 